import FeatureFlagService from "./featureFlagService";

export const featureFlagsService = new FeatureFlagService();
